import mixin from '../../mixins/Mixin';

export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const TICKER_TYPE = 'ticker';
  let modal = null;
  domc.addType(TICKER_TYPE, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          source: 'rss',
          config: btoa(JSON.stringify(config)),
          url: 'https://www.xul.fr/rss.xml',
          field: 'title',
          limit: 10,
          speed: 2,
          text:
            '1. Entrer votre texte ici.\n' +
            '2. Entrer votre texte ici.\n' +
            '3. Entrer votre texte ici.\n' +
            '4. Entrer votre texte ici.',
          jsonData: btoa('[]'),
          droppable: false,
          traits: [
            {
              type: 'select',
              label: 'Source',
              name: 'source',
              options: [{ value: 'rss', name: 'RSS' }, { value: 'text', name: 'Text' }],
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'URL',
              name: 'url',
              changeProp: 1,
              attributes: { 'data-related-type': 'rss' },
            },
            {
              type: 'text',
              label: 'Champ',
              name: 'field',
              changeProp: 1,
              attributes: { 'data-related-type': 'rss' },
            },
            {
              type: 'number',
              label: 'Limit',
              name: 'limit',
              changeProp: 1,
              attributes: { 'data-related-type': 'rss' },
            },
            {
              type: 'number',
              label: 'Vitesse',
              name: 'speed',
              changeProp: 1,
            },
          ],
          script: function() {
            const config = `{[ config ]}`;
            const conf = JSON.parse(atob(config));
            var loadingBtn = document.querySelector('.bn-loader-text');
            if (loadingBtn) loadingBtn.innerHTML = conf.translate.loading;
            const source = `{[ source ]}`;
            const url = `{[ url ]}`;
            const jsonData = `{[ jsonData ]}`;
            const field = `{[ field ]}`;
            const limit = `{[ limit ]}`;
            const speed = `{[ speed ]}`;
            const id = this.id;
            let opts = {
              scrollSpeed: speed,
              seperator: '<span class="bn-seperator">&#8226;</span>',
              errorMsg: 'Flux RSS non chargé. Veuillez réessayer.',
            };
            console.log(source);
            console.log('rss');
            console.log(source == 'rss');
            console.log(source === 'rss');
            console.log(source.indexOf('rss'));
            console.log(source.localeCompare('rss'));
            if (source == 'rss') {
              opts.type = 'rss';
              opts.usingApi = 'rss2json';
              opts.rss2jsonApiKey = 'sniu6hkmcvlqlrq3ep2g6s1o294xtccoqrvwzjtd'; //'5ivfzdrkuqwmoe0dgxeqvhfz0knlo7yq4fw20bt0'
              opts.limit = limit;
              opts.url = url;
              opts.showingField = field;
            } else {
              opts.type = 'localJson';
              opts.jsonData = atob(jsonData);
              opts.showingField = 'title';
            }
            $(document).ready(function () {
              $(`#${id} #newsTicker`).breakingNews({ source: opts });
              if (!$('.reveal').length) {
                $(`#${id} #newsTicker .bn-play`).click();
                $(`#${id}`).click();
              }
            });
          },
        }),
        isComponent: function(el) {
          if (el.getAttribute('data-gjs-type') === TICKER_TYPE) {
            return {
              type: TICKER_TYPE,
            };
          }
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: TICKER_TYPE };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      init() {
        this.listenTo(
          this.model,
          'change:url change:field change:limit change:speed',
          this.handleUpdate,
        );
        this.listenTo(this.model, 'change:source', this.handleUpdateSource);
        this.listenTo(this.model, 'change:text', this.handleUpdateJsonData);
        this.model.set(
          'config',
          btoa(JSON.stringify(mixin.methods.getLangCode('display-ticker-plugin'))),
        );

        modal = editor.Modal;
        setTimeout(() => {
          this.handleUpdate();
          const propertiesEl = document.getElementById('selected-element-properties');
          if (propertiesEl) {
            if (this.model.get('source') === 'text') {
              propertiesEl.classList.add('text');
            } else {
              propertiesEl.classList.remove('text');
            }
          }
        }, 1000);
      },
      events: {
        dblclick: 'openModal',
      },
      openModal() {
        if (this.model.get('source') === 'rss') {
          return;
        }
        modal.setContent(`
        <div class="modal-body">
          <textarea name="text" id="ticker-textarea" cols="30" rows="10" class="form-control">
            ${this.model.get('text')}
          </textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" id="save-ticker-text">
            ${config.translate.save}
          </button>
        </div>
       `);
      modal.setTitle(config.translate.modalTitle);
      modal.open();

        document.getElementById('save-ticker-text').addEventListener('click', e => {
          e.stopPropagation();
          this.model.set('text', document.getElementById('ticker-textarea').value);
          modal.close();
        });
      },
      handleUpdate() {
        const getAllComponents = (model, result = []) => {
          result.push(model);
          model.components().each((mod) => getAllComponents(mod, result));
          return result;
        };
        const all = getAllComponents(editor.DomComponents.getWrapper());
  
        let tickerModel = all.find((item) => item.attributes.attributes.id === this.el.id);
  
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));
  
        const updateComponent = (arr, index) => {
          if (arr[index].attributes.id === this.el.id) {
            arr[index] = tickerModel;
          } else {
            arr[index].components.forEach((m, i, a) => updateComponent(a, i));
          }
        };
  
        localStorageComponents.forEach((m, index, arr) => updateComponent(arr, index));
  
        this.updateScript();
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
      },
      
      handleUpdateSource: function () {
        const propertiesEl = document.getElementById('selected-element-properties');
        if (this.model.get('source') === 'text') {
          this.handleUpdateJsonData();
          this.openModal();
          propertiesEl.classList.add('text');
        } else {
          propertiesEl.classList.remove('text');
        }
        this.handleUpdate();
      },
      handleUpdateJsonData() {
        let data = this.model
          .get('text')
          .split('\\n')
          .map((t) => {
            return { title: t };
          });
        this.model.set('jsonData', btoa(JSON.stringify(data)));
        this.handleUpdate();
      },
      /*      getWrapper() {
        if (!this.wrapper) {
          this.wrapper = document.createElement('div');
        }
        return this.wrapper;
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        this.updateAttributes();
        this.el.appendChild(this.getWrapper());
        return this;
      }*/
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/ticker/components.js